import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import { requerido, numero, letras } from './Validaciones';
import { consultaUser } from './PefilFunction';

export const ConsultaSolicitudes = (tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            tipo: tipo
        }

        Post(`${Url}consultaSolicitudesAdmin`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const ConsultaDetalles = (idSolicitud, idEst, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idSolicitud: idSolicitud,
            idEst: idEst,
            tipo: tipo
        }
        
        Post(`${Url}consultaDetalles`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const ConsulEstCuenta = (idEst, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idEst: idEst,
        }

        Post(`${Url}consulEstCuenta`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const NoAceptarSolicitud = (tipo, idEst, motivo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idEst: idEst,
            tipo: tipo,
            motivo: motivo
        }

        Post(`${Url}NoAceptarSolicitud`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const AceptarSolicitud = (tipo, idEst, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idEst: idEst,
            tipo: tipo,
        }

        Post(`${Url}AceptarSolicitud`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const PagarAranceles = (id, campos, tipo, respuesta) => {
    let status = "Ok";
    let mensaje = "Haz registrado correctamente el pago del estudiante";
    let tipoMes = "info";
    let errores = 0

    /* Validaciones globales*/
    requerido(errores, campos.fecha, "", "", "", "Debes ingresar la Fecha de la Transferencia", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    requerido(errores, campos.factura, "", "", "", "Debes ingresar el Número de la Factura", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    if (campos.metodoSelect.label !== "DIVISA"){
        if(campos.total === true){
            requerido(errores, campos.deudaT.totalGral, "", "", "", "El Monto Total no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.deudaT.totalGral !== ""){
                numero(errores, campos.deudaT.totalGral, "", "", "El campo Monto Total debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }else{
            requerido(errores, campos.otroMonto, "", "", "", "El Monto no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.otroMonto !== ""){
                numero(errores, campos.otroMonto, "", "", "El campo Otro Monto debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }
    }

    /* Validaciones específicas */
    switch (campos.metodoSelect.label) {
        case "EFECTIVO":
            /* Sin validaciones adicionales */
        break;
        case "DIVISA":
            requerido(errores, campos.divisas, "", "", "", "Debes ingresar el monto del pago en divisas", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });

            requerido(errores, campos.igtfV, "", "", "", "El monto del IGTF no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });

            if (campos.divisas !== ""){
                numero(errores, campos.divisas, "", "", "El campo Monto en divisas debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        break;
        case "TRANSFERENCIA":
            requerido(errores, campos.selectcuenta.value, "", "", "", "Debes seleccionar la Cuenta de la Transferencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        break;
        case "DEBITO":
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        case "CREDITO":
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        default: break;
    }

    if (status === "Ok"){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                id: id,
                campos: campos,
                tipo: tipo
            }

            Post(`${Url}pagarAranceles`, Content, (resp) => {
                let data = JSON.parse(resp);
                let Content2 = {
                    uId: cookie[1],
                    id: data.recibo,
                    factura: campos.factura,
                }

                mensaje = data.mess;
                let total = data.total;
                Post(`${Url}AprobarTransSolic`, Content2, (resp) => {
                    respuesta([status, mensaje, tipoMes, total])
                });
            });
        });
    }else{
        respuesta([status, mensaje, tipoMes])
    }
}

export const PagarAllCuotas = (id, campos, respuesta) => {
    let status = "Ok";
    let mensaje = "Haz registrado correctamente el pago del estudiante";
    let tipoMes = "info";
    let errores = 0

    requerido(errores, campos.fecha, "", "", "", "Debes ingresar la Fecha de la Transferencia", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje = resp[2];
            tipoMes = "error";
        }
    });

    requerido(errores, campos.factura, "", "", "", "Debes ingresar el Número de la Factura", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje = resp[2];
            tipoMes = "error";
        }
    });

    if (campos.metodoPValue.label === "DIVISA"){
        requerido(errores, campos.divisas, "", "", "", "Debes ingresar el monto del pago en divisas", (resp) => {
            if (resp[1] > 0){
                status = "Error";
                mensaje = resp[2];
                tipoMes = "error";
            }
        });

        if (campos.divisas !== ""){
            numero(errores, campos.divisas, "", "", "El campo Monto en divisas debe contener solo números", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje = resp[2];
                    tipoMes = "error";
                }
            });
        }
    }

    if (campos.cuotasP.length === 0){
        status = "Error";
        mensaje = "Debes seleccionar al menos una cuota"
        tipoMes = "error";
    }

    if (campos.metodoPValue.label !== "DIVISA"){
        if(campos.total === true){
            requerido(errores, campos.deudaT.totalGral, "", "", "", "El Monto Total no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.deudaT.totalGral !== ""){
                numero(errores, campos.deudaT.totalGral, "", "", "El campo Monto Total debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }else{
            requerido(errores, campos.otroMonto, "", "", "", "El Monto no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.otroMonto !== ""){
                numero(errores, campos.otroMonto, "", "", "El campo Otro Monto debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }
    }

    if (status === "Ok"){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                id: id,
                campos: campos,
                tipo: campos.metodoPValue
            }

            Post(`${Url}PagarAllCuotas`, Content, (resp) => {
                let data = JSON.parse(resp);

                if(data.status === "Error"){
                    status = "Error";
                    mensaje = data.mess
                    tipoMes = "error";

                    respuesta([status, mensaje, tipoMes])
                }else{
                    let Content2 = {
                        uId: cookie[1],
                        id: data.recibo,
                        factura: campos.factura,
                    }
                    mensaje = data.mess;
                    let total = data.total;
                    Post(`${Url}AprobarTransSolic`, Content2, () => {
                        respuesta([status, mensaje, tipoMes, total])
                    });
                }
            });
        });
    }else{
        respuesta([status, mensaje, tipoMes])
    }
}

export const PagarSolicitud = (id, campos, tipo, id2, respuesta) => {
    let status = "Ok";
    let mensaje = "Haz registrado correctamente el pago del estudiante";
    let tipoMes = "info";
    let errores = 0

    /* Validaciones globales*/
    requerido(errores, campos.fecha, "", "", "", "Debes ingresar la Fecha de la Transferencia", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    requerido(errores, tipo.value, "", "", "", "Debes seleccionar el Tipo de Solicitud", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    requerido(errores, campos.factura, "", "", "", "Debes ingresar el Número de la Factura", (resp) => {
        if (resp[1] > 0){
            status = "Error";
            mensaje= resp[2];
            tipoMes = "error";
        }
    });

    if (campos.metodoSelect.label !== "DIVISA"){
        if(campos.total === true){
            requerido(errores, campos.deudaT.totalGral, "", "", "", "El Monto Total no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.deudaT.totalGral !== ""){
                numero(errores, campos.deudaT.totalGral, "", "", "El campo Monto Total debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }else{
            requerido(errores, campos.otroMonto, "", "", "", "El Monto no puede estar vacío", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.otroMonto !== ""){
                numero(errores, campos.otroMonto, "", "", "El campo Otro Monto debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        }
    }

    /* Validaciones específicas */
    switch (campos.metodoSelect.label) {
        case "EFECTIVO":
            /* Sin validaciones adicionales */
        break;
        case "DIVISA":
            requerido(errores, campos.divisas, "", "", "", "Debes ingresar el monto del pago en divisas", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            if (campos.divisas !== ""){
                numero(errores, campos.divisas, "", "", "El campo Monto en divisas debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        break;
        case "TRANSFERENCIA":
            requerido(errores, campos.selectcuenta.value, "", "", "", "Debes seleccionar la Cuenta de la Transferencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        break;
        case "DEBITO":
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        case "CREDITO":
            requerido(errores, campos.num, "", "", "", "Debes ingresar el Número de Referencia", (resp) => {
                if (resp[1] > 0){
                    status = "Error";
                    mensaje= resp[2];
                    tipoMes = "error";
                }
            });
        
            if (campos.num !== ""){
                numero(errores, campos.num, "", "", "El campo N° de Referencia debe contener solo números", (resp) => {
                    if (resp[1] > 0){
                        status = "Error";
                        mensaje= resp[2];
                        tipoMes = "error";
                    }
                });
            }
        default: break;
    }

    if (status === "Ok"){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                id: id,
                id2: id2,
                campos: campos,
                tipo: tipo
            }
            
            Post(`${Url}pagarSolicitud`, Content, (resp) => {
                let data = JSON.parse(resp);
                let Content2 = {
                    uId: cookie[1],
                    id: data.recibo,
                    factura: campos.factura
                }

                mensaje = data.mess;
                let total = data.total;
                Post(`${Url}AprobarTransSolic`, Content2, (resp) => {
                    respuesta([status, mensaje, tipoMes, total])
                });
            });
        });
    }else{
        respuesta([status, mensaje, tipoMes])
    }
}

export const ConsultBecas = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}consultBecaEst`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        })
    })
}

export const ConsultDataBeca = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}ConsultDataBeca`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        })
    })
}

export const ConsultDataBecas = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}ConsultDataBecas`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        })
    })
}

export const ConsultCarrera = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}carrerActual`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        })
    })
}

export const ConsultBecado = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}ConsultBecado`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta([data[0], data[1]])
        })
    })
}

export const BecasSolicitadas = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}becasSolicitadas`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        })
    })
}

export const ConsultDatosEst = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }
        Post(`${Url}ConsultDatosEst`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        })
    })
}


export const SolicitarBeca = (tipo, data1, data2, data3, data4, data5, data6, data7, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
            tipo: tipo,
            data1: data1,
            data2: data2,
            data3: data3,
            data4: data4,
            data5: data5,
            data6: data6,
            data7: data7,
        }

        Post(`${Url}solicitarBeca`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        })
    })
}

export const ConsultaRequisitos = (respuesta) => {
    Post(`${Url}verRequisitosBeca`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    })
}

export const ChkDatos = (data1, data2, data3, data4, data5, data6, data7, respuesta) => {
    let errores = 0;
    let nameErr = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo realizar la solicitud. Revisa los errores encontrados para continuar"
    }]

    let campo = "";
    for (let i in data1){
        (data1[i].value === undefined) ? campo = data1[i].text : campo = data1[i].value;

        if (data1[i].errMess !== "") requerido(errores, campo, "", "", "", data1[i].errMess, (resp) => {
            if (resp[2] !== ""){
                errores = resp[1];
                nameErr.push(resp[2])
            }
        });
    }

    for (let i in data2){
        (data2[i].value === undefined) ? campo = data2[i].text : campo = data2[i].value;

        if (data2[i].errMess !== "") requerido(errores, campo, "", "", "", data2[i].errMess, (resp) => {
            if (resp[2] !== ""){
                errores = resp[1];
                nameErr.push(resp[2])
            } 
        });
    }
    
    for (let i in data3){
        (data3[i].value === undefined) ? campo = data3[i].text : campo = data3[i].value;

        if (data3[i].errMess !== "") requerido(errores, campo, "", "", "", data3[i].errMess, (resp) => {
            if (resp[2] !== ""){
                errores = resp[1];
                nameErr.push(resp[2])
            } 
        });
    }

    for (let i in data4){
        (data4[i].value === undefined) ? campo = data4[i].text : campo = data4[i].value;

        if (data4[i].errMess !== "") requerido(errores, campo, "", "", "", data4[i].errMess, (resp) => {
            if (resp[2] !== ""){
                errores = resp[1];
                nameErr.push(resp[2])
            } 
        });
    }

    for (let i in data5){
        (data5[i].value === undefined) ? campo = data5[i].text : campo = data5[i].value;

        if (data5[i].errMess !== "") requerido(errores, campo, "", "", "", data5[i].errMess, (resp) => {
            if (resp[2] !== ""){
                errores = resp[1];
                nameErr.push(resp[2])
            } 
        });
    }

    for (let i in data7){
        let preg = ""
        switch (i) {
            case "preg1Select": preg = "pregunta 1"; break;
            case "preg2Select": preg = "pregunta 2"; break;
            case "preg3Select": preg = "pregunta 3"; break;
            case "preg4Select": preg = "pregunta 4"; break;
        }

        requerido(errores, data7[i], "", "", "", `Debes seleccionar una opción de la ${preg}`, (resp) => {
            errores = resp[1];
            nameErr.push(resp[2])
        })
    }

    respuesta([mensaje, errores, nameErr])
}

export const ConsultPreguntas = (respuesta) => {
    Post(`${Url}ConsultPreguntas`, "", (resp) => {
        let data = JSON.parse(resp);
        let preguntas1 = [];
        let preguntas2 = [];
        let preguntas3 = [];
        let preguntas4 = [];

        for (let i in data[0]) {
            preguntas1.push({ id: data[0][i].id, nombre: data[0][i].nombre_pregunta })
        }

        for (let i in data[1]) {
            preguntas2.push({ id: data[1][i].id, nombre: data[1][i].nombre_pregunta })
        }

        for (let i in data[2]) {
            preguntas3.push({ id: data[2][i].id, nombre: data[2][i].nombre_pregunta })
        }

        for (let i in data[3]) {
            preguntas4.push({ id: data[3][i].id, nombre: data[3][i].nombre_pregunta })
        }

        respuesta([preguntas1, preguntas2, preguntas3, preguntas4])
    })
}


// WEBPACK FOOTER //
// ./src/funciones/SolicitudesFunction.jsx